import {FrameworkHours} from "./frameworkHours";

export function Hours(props) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            {props.frameworks.map(f => ( <FrameworkHours f={f} frameworksHours={props.frameworksHours} setFrameworksHours={props.setFrameworksHours}/>
            ))}
        </div>
    );
}